export enum PermissionEnum {
  READ =  'Read',
  READ_ALL =  'ReadAll',
  CREATE =  'Create',
  UPDATE =  'Update',
  DELETE =  'Delete',
  ACTIVATE =  'Activate',
  DE_ACTIVATE =  'DeActivate'
}
